import React, { useState } from "react";
import { useSelector } from "react-redux";
import Storefront1 from "assets/images/Shopify-Storefront---1.jpg";
import Storefront2 from "assets/images/Shopify-Storefront---2.jpg";
import Button from "components/Button";

import {
  Container,
  Heading,
  Detail,
  Row1,
  Row2,
  Img,
} from "styles/pages/connect-to-shopify";
import TextField from "components/TextField";

const ConnectToShopify = () => {
  const [storeName, setStoreName] = useState(undefined);
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);

  return (
    <Container>
      <Heading>Register a Store</Heading>
      <Detail>
        <h2>Connect To Shopify</h2>
        <Row1>
          <div>
            <TextField
              label="Shopify storefront address"
              onChange={(value) => setStoreName(value)}
            />
            <Button
              disabled={!storeName?.trim().length || storeName?.includes(".")}
              title="Connect Store"
              onClick={() =>
                window.open(
                  `https://${storeName}.myshopify.com/admin/oauth/authorize?client_id=c4d47a7212ba498f12220c3a8ce1fc45&scope=read_products,write_products,read_product_listings,read_orders,write_orders&redirect_uri=https://bot2-app.herokuapp.com/shopifyRedirectedUrl&state=${storeName}.myshopify.com/${emailid}&grant_options[]=`
                )
              }
            />
          </div>
          <div>
            <label>How can I find my Shopify Storefront Address?</label>
            <p>
              Your Shopify storefront address will be in the format
              your_shop_name.myshopify.com and is the default address provided
              to you by Shopify when you first opened your store.
            </p>
            <p>
              If you can't remember your shop name you can find it by logging
              into your Shopify admin. There are two ways you should be able to
              find your shop name:
            </p>
          </div>
        </Row1>
        <p
          style={{
            color: "red",
            margin: "20px",
            fontWeight: "bold",
            fontSize: "20px",
          }}
        >
          If you are facing any issue while conecting the store, please contact
          developer@bigoventees.com to connect your store.
        </p>
        <Row2>
          <Img src={Storefront1} alt="Storefront1" />
          <Img src={Storefront2} alt="Storefront2" />
        </Row2>
      </Detail>
    </Container>
  );
};

export default ConnectToShopify;
